var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';

var TableRow = function TableRow(_ref) {
  var data = _ref.data,
      currency = _ref.currency;

  return React.createElement(
    'tr',
    null,
    React.createElement(
      'td',
      null,
      data.Id
    ),
    React.createElement(
      'td',
      null,
      React.createElement(FormattedDate, {
        value: data.Created,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    ),
    React.createElement(
      'td',
      null,
      data.Transactions[0].Description
    ),
    React.createElement(
      'td',
      null,
      data.Transactions[0].Odds
    ),
    React.createElement(
      'td',
      null,
      data.Transactions[0].Status
    ),
    React.createElement(
      'td',
      null,
      React.createElement(FormattedNumber, {
        value: data.TotalWager,
        style: 'currency',
        currency: currency
      })
    ),
    React.createElement(
      'td',
      null,
      React.createElement(FormattedNumber, {
        value: data.TotalWin,
        style: 'currency',
        currency: currency
      })
    )
  );
};

var TableMobileRow = function TableMobileRow(_ref2) {
  var data = _ref2.data;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'tr',
      { className: 'bg-black-d2' },
      React.createElement(
        'th',
        null,
        '#'
      ),
      React.createElement(
        'td',
        null,
        data.Id
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, { id: 'label.game', defaultMessage: 'Game' })
      ),
      React.createElement(
        'td',
        null,
        data.Transactions[0].Description
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, { id: 'history.table.date', defaultMessage: 'Date' })
      ),
      React.createElement(
        'td',
        { title: data.Created },
        React.createElement(FormattedDate, {
          value: data.Created,
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, { id: 'history.table.status', defaultMessage: 'Status' })
      ),
      React.createElement(
        'td',
        null,
        data.Transactions[0].Status
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, { id: 'history.table.bet', defaultMessage: 'Bet' })
      ),
      React.createElement(
        'td',
        null,
        data.TotalWager
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, { id: 'history.table.win', defaultMessage: 'Win' })
      ),
      React.createElement(
        'td',
        null,
        data.TotalWin
      )
    )
  );
};

/**
 * Table to present payment history in user account
 */

var SportsbookHistoryTable = function (_Component) {
  _inherits(SportsbookHistoryTable, _Component);

  function SportsbookHistoryTable() {
    _classCallCheck(this, SportsbookHistoryTable);

    return _possibleConstructorReturn(this, (SportsbookHistoryTable.__proto__ || Object.getPrototypeOf(SportsbookHistoryTable)).apply(this, arguments));
  }

  _createClass(SportsbookHistoryTable, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        null,
        this.props.orientation === 'horizontal' && React.createElement(
          'table',
          { className: 'table' },
          React.createElement(
            'tbody',
            null,
            React.createElement(
              'tr',
              null,
              React.createElement(
                'th',
                null,
                '#'
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, { id: 'history.table.date', defaultMessage: 'Date' })
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, { id: 'history.table.game', defaultMessage: 'Game' })
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, { id: 'history.table.odds', defaultMessage: 'Odds' })
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, {
                  id: 'history.table.status',
                  defaultMessage: 'Status'
                })
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, { id: 'history.table.bet', defaultMessage: 'Bet' })
              ),
              React.createElement(
                'th',
                null,
                React.createElement(Translate, { id: 'history.table.win', defaultMessage: 'Win' })
              )
            ),
            this.props.data.map(function (item) {
              return React.createElement(TableRow, {
                key: item.Id,
                data: item,
                currency: _this2.props.currency
              });
            })
          )
        ),
        this.props.orientation === 'vertical' && React.createElement(
          'table',
          { className: 'table' },
          React.createElement(
            'tbody',
            null,
            this.props.data.map(function (item) {
              return React.createElement(TableMobileRow, { key: item.Id, data: item });
            })
          )
        ),
        this.props.data.length === 0 && React.createElement(
          'div',
          { className: 'no-transactions-data' },
          React.createElement(Translate, { defaultMessage: 'No data', id: 'history.table.no_data' })
        )
      );
    }
  }]);

  return SportsbookHistoryTable;
}(Component);

SportsbookHistoryTable.propTypes = {
  /** Collection of items */
  data: PropTypes.arrayOf(PropTypes.shape({
    /** Amount of deposit/Withdraw */
    Amount: PropTypes.number,
    /** Type of currency */
    Currency: PropTypes.string,
    /** Status of the transaction */
    Status: PropTypes.string,
    /** Type of transaction */
    TransactionType: PropTypes.string,
    /** Date of transaction */
    Started: PropTypes.string
  })),
  /** Decides if it should be desktop or mobile */
  orientation: PropTypes.string
};
SportsbookHistoryTable.defaultProps = {
  data: [],
  orientation: 'horizontal'
};


export default SportsbookHistoryTable;